export default "__VITE_ASSET__DY$34N7h__"